import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator';
import { Menu, Icon } from 'ant-design-vue';
import { RouterItem } from '@/utils/interfaces';
import { getMenuRoutes } from '@/router';
import sessionModule, { IUserSession } from '@/store/modules/session';
import { State } from 'vuex-class';

function getParentPaths(path: string) {
  const result: string[] = [];
  const arr = path.split('/');
  for (let i = arr.length - 1; i > 1; i--) {
    const xx = arr.slice(0, i);
    result.push(xx.join('/'));
  }
  return result;
}

@Component({
  components: {
    'a-menu': Menu,
    'a-submenu': Menu.SubMenu,
    'a-menu-item-group': Menu.ItemGroup,
    'a-menu-item': Menu.Item,
    'a-icon': Icon,
  },
})
export default class MenuList extends Vue {
  @Prop({ default: '#010101' }) private bgColor!: string;

  @Prop({ default: '#fff' }) private txtColor!: string;

  @State(s => s.session.activeSession) currentSession: IUserSession;

  keys: string[] = [];

  openKeys: string[] = [];

  @Watch('$route', { immediate: true, deep: true })
  routeChange(to: any, from: any) {
    this.openKeys = getParentPaths(to.path);
    this.keys = [to.path, ...this.openKeys];
  }

  openChange(openKeys: string[]) {
    this.openKeys = openKeys;
  }

  onTitleClick(val: any) {
    // console.log('menu onTitleClick:', arguments);
  }

  render() {
    // const { menuData, sidebar: { opened } } = this.$store.state.app;
    const menuData = getMenuRoutes(); // permissionModule.routers;
    return (
      <a-menu
        mode="inline"
        class="left-menu"
        // theme="dark"
        openKeys={this.openKeys}
        on-openChange={this.openChange}
        selectedKeys={this.keys}
      >
        {menuData ? this.renderMenu(menuData) : null}
      </a-menu>
    );
  }

  renderMenu(menuData: RouterItem[], parentPath?: string): Array<JSX.Element | null> {
    // menuData = menuData.filter((child) => child.meta && !child.meta.hidden);
    // 有子菜单: 1. 所有子菜单都hidden 则不显示。 2.只有一个非hidden菜单，则此子菜单提升一级
    // 无子菜单则判断当前节点
    return menuData.map((item: RouterItem) => {
      if (item.meta && item.meta!.hidden === true) {
        return null;
      }

      if (item.children && item.children.length > 0) {
        const showedChildren = item.children!.filter((o: RouterItem) => o.meta && o.meta!.hidden !== true);
        // console.log('child:', item.path, item.children.length, showedChildren.length);
        if (showedChildren.length === 0 && item.meta && item.meta!.hidden !== true) {
          // 无子菜单
          return this.renderMenuItem(item, parentPath);
        } else if (item.children && item.meta && item.meta!.concede === true) {
          // 提升所有子菜单
          const p = parentPath ? `${parentPath}/${item.path}` : item.path;
          return this.renderMenu(item.children!, p) as any;
        } else if (showedChildren.length === 1 && item.children![0].meta && item.children![0].meta.concede !== true) {
          // 只有一个子菜单，提升子菜单或者层级显示
          if (item.meta && item.meta!.alwaysShow === true) {
            // console.log('renderSubMenuItem:', item.path);
            return this.renderSubMenuItem(item, parentPath);
          } else {
            // console.log('提升子菜单:', item);
            const p = parentPath ? `${parentPath}/${item.path}` : item.path;
            return this.renderMenuItem(item.children[0], p);
          }
        } else {
          return this.renderSubMenuItem(item, parentPath);
        }
      } else if (item.meta && item.meta!.hidden !== true) {
        return this.renderMenuItem(item, parentPath);
      }
      return null;
    });
  }

  renderMenuItem(item: RouterItem, parentPath?: string): JSX.Element | null {
    if (item.name === 'dataDisplay' && this.currentSession.deptName !== '共青团广西区委') {
      return null;
    }
    if (item.name === 'type-statistics' && this.currentSession.deptName == '共青团广西区委') {
      return null;
    }
    if (item.name === 'tag-statistics' && this.currentSession.userName !== 'gxgqt') {
      return null;
    }

    const path = parentPath ? `${parentPath}/${item.path}`.replace('//', '/') : item.path;
    // console.log('renderMenuItem:', parentPath, ',', path, ',', { name: item.name, path: item.path })
    // const path = item.path;
    return (
      <a-menu-item id={path} key={`${path}`}>
        <router-link to={`${path}`}>
          {item.meta && item.meta!.icon ? <a-icon type={item.meta!.icon}></a-icon> : ''}
          <span>{item.meta ? item.meta.title : item.name}</span>
        </router-link>
      </a-menu-item>
    );
  }

  renderSubMenuItem(item: RouterItem, parentPath?: string): JSX.Element | null {
    // console.log('renderSubMenuItem:', parentPath, ',', { name: item.name, path: item.path })
    const path = (parentPath ? `${parentPath}/${item.path}` : item.path).replace('//', '/');
    return (
      <a-submenu id={path} key={path} on-titleClick={this.onTitleClick}>
        <template slot="title">
          {item.meta && item.meta!.icon ? <a-icon type={item.meta!.icon}></a-icon> : ''}
          <span>{item.meta ? item.meta.title : item.name}</span>
        </template>
        {this.renderMenu(item.children as any, path)}
      </a-submenu>
    );
  }
}
